import { cn } from '@shadcn/lib/utils';
import { Label as ShadcnLabel } from '@shadcn/ui/label';
import React from 'react';

type LabelProps = React.ComponentProps<'label'>;

export function Label({ className, ...props }: LabelProps) {
  return <ShadcnLabel className={cn('text-foreground text-md font-regular', className)} {...props} />;
}
